<form class="general-information" [formGroup]="accountSettingForm" (ngSubmit)="onSubmit()" novalidate>

	<h3 class="white">
		<span i18n="@@setting.general_information">General Information</span>
	</h3>


	<div class="mixed-fields">

		<fieldset [ngClass]="{ 'has-error': (isSubmitted || f.business_name?.dirty) && f.business_name.errors }">
			<label><ng-container i18n="@@business.business_name">Business Name</ng-container><span class="req-star">*</span></label>
			<input type="text" formControlName="business_name" class="business-name" />
			<span class="field-error" i18n="@@error.business_name_required" *ngIf="(isSubmitted || f.business_name.dirty) && f.business_name.errors?.required">Business name is required</span>
			<span class="field-error" *ngIf="isSubmitted && f.business_name.errors?.serverError">{{ f.business_name.errors?.serverError }}</span>
		</fieldset>

		<fieldset class="full-name half" [ngClass]="{ 'has-error': (isSubmitted || f.first_name.dirty) && f.first_name?.errors }">
			<label><ng-container i18n="@@general.first_name">First Name</ng-container><span class="req-star">*</span></label>
			<input type="text" formControlName="first_name" class="first-name" />
			<span i18n="@@error.required.first_name" *ngIf="(isSubmitted || f.first_name.dirty) && f.first_name.errors?.required" class="field-error">First name is required</span>
			<span class="field-error" i18n="@@validation.errors.enter_valid_first_name" *ngIf="(isSubmitted || f.first_name.dirty) && f.first_name.errors?.pattern" >Please enter valid first name</span>
			<span class="field-error" i18n="@@validation.errors.first_name_less_than_100_character" *ngIf="(isSubmitted || f.first_name.dirty) && f.first_name.errors?.maxlength" >First name must be less than 100 characters</span>

		</fieldset>

		<fieldset class="last-name half" [ngClass]="{ 'has-error': (isSubmitted || f.last_name.dirty) && f.last_name?.errors }">
			<label><ng-container i18n="@@general.last_name">Last Name</ng-container><span class="req-star">*</span></label>
			<input type="text" formControlName="last_name" class="last-name" />
			<span i18n="@@error.required.last_name" class="field-error" *ngIf="(isSubmitted || f.last_name.dirty) && f.last_name.errors?.required">Last name is required</span>
			<span class="field-error" i18n="@@validation.errors.enter_valid_last_name" *ngIf="(isSubmitted || f.last_name.dirty) && f.last_name.errors?.pattern" >Please enter valid last name</span>
			<span class="field-error" i18n="@@validation.errors.last_name_less_than_100_character" *ngIf="(isSubmitted || f.last_name.dirty) && f.last_name.errors?.maxlength" >Last name must be less than 100 characters</span>
		</fieldset>

		<fieldset class="contact-phone oneThird" [ngClass]="{ 'has-error':( isSubmitted || f.phone.dirty) && f.phone?.errors }">
			<label>
				<ng-container i18n="@@general.phone">Phone</ng-container><span class="req-star">*</span>
				<!-- <i i18n="@@general.contact_message"> (Value must be between 5 and 30 digits)</i> -->
			</label>
			<div class="tel-input-group">
				<input type="text" formControlName="dial_code" id="countryCode" name="country_code" readonly class="dial-code text-center">
				<input type="tel" formControlName="phone" id="phone1" i18n-placeholder="@@clients.client_phone" placeholder="Phone" name="phone" maxlength="30" class="phone-with-code">
			</div>

			<span i18n="@@error.required.contact" class="field-error" *ngIf="(isSubmitted || f.phone.dirty) && f.phone.errors?.required">Contact number is required </span>
			<span class="field-error" i18n="@@error.phone_number_only" *ngIf="(isSubmitted || f.phone.dirty) && f.phone.errors?.pattern">Please enter number only </span>
			<span class="field-error" i18n="@@error.required.contact_number_between" *ngIf="(isSubmitted || f.phone.dirty) && (f.phone.errors?.minlength || f.phone.errors?.maxlength)">The contact number must be between 5 and 30 digits</span>
			<span class="field-error" *ngIf="f.phone.errors?.serverError">{{ f.phone.errors?.serverError }}</span>
		</fieldset>

		<fieldset class="email oneThird" [ngClass]="{ 'has-error':(isSubmitted || f.email.dirty) && f.email?.errors }">
			<label><ng-container i18n="@@common.email">Email</ng-container><span class="req-star">*</span></label>
			<input type="email" formControlName="email" class="email" />
			<span i18n="@@error.required.email" class="field-error" *ngIf="(isSubmitted || f.email.dirty) && f.email.errors?.required">Email is required</span>
			<span class="field-error" i18n="@@error.valid_email" *ngIf="(isSubmitted || f.email.dirty) && f.email.errors?.email">Please enter valid email address</span>
			<span class="field-error" *ngIf="f.email.errors?.serverError">{{ f.email.errors?.serverError }}</span>
		</fieldset>
		<fieldset class="colourPalette" [ngClass]="{ 'has-error': f.submitted && f.color_palette.errors }">
			<label i18n="@@business.color_palette">Colour Palette</label>
			<div class="sp-original-input-container">
				<div class="sp-colorize-container sp-add-on">
					<input type="color" name="color_palette" id="color-palette" [color]="f.color_palette.value" formControlName="color_palette" color-picker (ngModelChange)="updateColorPalette($event)">
				</div>
			</div>
			<span class="field-error" i18n="@@error.color_palette_required" *ngIf="f.submitted && f.color_palette.errors?.required">Colour palette is required</span>
			<span class="field-error" *ngIf="f.submitted && f.color_palette.errors?.serverError">{{ f.color_palette.errors?.serverError }}</span>
		</fieldset>

		<ng-container *ngIf="showChangePasswordBlock">

			<h3 class="white"><span i18n="@@general.change_password">Change password</span></h3>

			<fieldset class="old-password oneThird" [ngClass]="{ 'has-error':( isSubmitted || f.old_password.dirty) && f.old_password?.errors }">
				<label><ng-container i18n="@@general.old_password">Old Password</ng-container><span class="req-star">*</span></label>
				<input type="password" formControlName="old_password" class="old-password" placeholder="********" />
				<span class="field-error" i18n="@@error.password_atleast" *ngIf="(isSubmitted || f.old_password.dirty) && (f.old_password.errors?.minlength)">Password needs to be at least 6 characters long</span>
				<span i18n="@@error.required.old_password" class="field-error" *ngIf="(isSubmitted || f.old_password.dirty) && f.old_password.errors?.required">Old Password is required</span>
				<span class="field-error" *ngIf="f.old_password.errors?.serverError">{{ f.old_password.errors?.serverError }}</span>
			</fieldset>

			<fieldset class="new-password oneThird" [ngClass]="{ 'has-error':( isSubmitted || f.new_password.dirty) && (f.new_password?.errors || accountSettingForm.errors?.bothPasswordRequired ) }">
				<label><ng-container i18n="@@general.new_password">New Password</ng-container><span class="req-star">*</span></label>
				<input type="password" formControlName="new_password" class="new-password" placeholder="********" />
				<small i18n="@@general.new_password_message">(New password needs to be at least 6 characters long)</small>
				<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.confirm_password) && accountSettingForm.errors?.bothPasswordRequired">Required</span>
				<span class="field-error" i18n="@@error.password_atleast" *ngIf="(isSubmitted || f.new_password.dirty) && (f.new_password.errors?.minlength)">Password needs to be at least 6 characters long</span>
				<span class="field-error" *ngIf="f.new_password.errors?.serverError">{{ f.new_password.errors?.serverError }}</span>
			</fieldset>

			<fieldset class="confirm-password oneThird" [ngClass]="{ 'has-error':( isSubmitted || f.confirm_password.dirty) && (f.confirm_password?.errors || accountSettingForm.errors?.passwordNotMatch || accountSettingForm.errors?.bothPasswordRequired ) }">
				<label><ng-container i18n="@@general.confirm_password">Confirm Password</ng-container><span class="req-star">*</span></label>
				<input type="password" formControlName="confirm_password" class="confirm-password" placeholder="********" />
				<span class="field-error" i18n="@@error.required" *ngIf="(isSubmitted || f.confirm_password) && accountSettingForm.errors?.bothPasswordRequired">Required</span>
				<span class="field-error" i18n="@@error.password_atleast" *ngIf="(isSubmitted || f.confirm_password.dirty) && (f.confirm_password.errors?.minlength)">Password needs to be at least 6 characters long</span>
				<span class="field-error" i18n="@@error.confirm_password_same_new_password" *ngIf="(isSubmitted || f.confirm_password) && accountSettingForm.errors?.passwordNotMatch">Password and confirmation password must be the same</span>
			</fieldset>

		</ng-container>

	</div>

	<fieldset class="logo-uploder">
    <label i18n="@@general.logo">Logo</label>
    <!-- <input type="file" accept="image/png, image/jpeg, image/gif" class="d-none" (change)="onLogoChange($event, logoFile)" #logoFile/> -->

    <file-pond #logoFile
			[options]="pondOptions"
			[files]="logoUrl"
    	(oninit)="pondHandleInit()"
			(onaddfile)="pondHandleAddFile($event)"
			(onprocessfileabort)="pondHandleRemoveFile($event)"
			>
		</file-pond>
  </fieldset>

	<div class="account-setting__actionButtonsWrap">
		<button type="button" class="tu-btn pink transparent" [hidden]="showChangePasswordBlock" i18n="@@button.change_password" (click)="showChangePasswordBlock = true;">Change Password</button>
		<button i18n="@@button.save" type="submit" class="tu-btn pink save-btn">Save</button>
	</div>
</form>
